import React, { useState, useEffect, useMemo, useCallback } from 'react';
import apiClient from '../../../api/apiClient';
import { useNavigate } from 'react-router-dom';
import { subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Table, Form, InputGroup, Container, Row, Col, Pagination, Button } from 'react-bootstrap';
import { AlertMassage, Input, StatusCard } from '../../shared';
import { getTags, formatDate, getCourseLessonCountByType, useImageWithFallback } from '../../../utils/utils';
import { SuccessIcon, VideoPlayIcon, BackArrowIcon } from '../../../utils/FontIcon';
import { GETCOURSELIST } from '../../../utils/ApiEndPoint';

const CourseImage = ({ course }) => {
  const thumbnailUrl = course?.thumbnailUrl || '/lms/img/no-video-icon.png';
  const fallbackUrl = '/lms/img/no-video-icon.png';
  const [imgSrc, handleImgError] = useImageWithFallback(thumbnailUrl, fallbackUrl);
  return (<Row className='align-items-center'>
    <Col xs={5}>
      <a
        title={course.title}
        style={{ position: 'relative', display: 'flex', gap: '10px', textDecoration: 'none' }}
      >
        <span className='p-relative course-thumbnail-list'>
          <img src={imgSrc} onError={handleImgError} alt={course.title} title='Video Thumbnail' className='img-fluid video-thumnail' />
          <VideoPlayIcon className='video-playbtn' />
        </span>
      </a>
    </Col>
    <Col xs={7}>
      <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}>{course.title}</span></span>
    </Col>
  </Row>);
}
const CourseDetailTr = ({ course, idx, currentPage, pageSize, handelAction, handelAccessMode }) => {
  const statusClass = course.status === 'draft' ? 'pending' : course.status === 'rejected' ? 'reject' : course.status === 'published' ? 'approve' : '';
  const modules = course?.modules && typeof course.modules === "string" ? JSON.parse(course.modules) : [];
  const lesson = modules.length && typeof modules[0].lessons === "string" ? JSON.parse(modules[0].lessons) : [];
  const totalVideos = getCourseLessonCountByType(lesson, 'video');
  const totalAssessments = getCourseLessonCountByType(lesson, 'quiz');
  const totalReferences = getCourseLessonCountByType(lesson, 'ref_doc');
  return (
    <tr key={idx + (currentPage - 1) * pageSize}>
      <td className='txt-center'>
        {(currentPage - 1) * pageSize + idx + 1}
      </td>
      <td style={{ maxWidth: '120px', cursor: 'pointer' }} onClick={e => handelAction(e, course)}>
        <CourseImage course={course} />
      </td>
      <td> <span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}></span><span className='inline-block text-muted' > {course.description}</span></span></td>
      <td><span className='d-block'><span className='inline-block' style={{ fontSize: '0.75rem', fontWeight: '500' }}></span><span className='inline-block text-muted' >{course.tags && course.tags.length ? getTags(course.tags) : ''}</span></span></td>
      <td className='txt-center'>{totalVideos}</td>
      <td className='txt-center'>{totalAssessments}</td>
      <td className='txt-center'>{totalReferences}</td>
      <td>{formatDate(course.createdAt)}</td>
      <td>{course.createdBy ? course.createdBy : ''}</td>
      <td>
        <span className={`course-status ${statusClass}`}>{course.status}</span>
      </td>
      <td>
        {course.status === 'draft' ?
          <div style={{ display: 'flex', paddingBlock: '1rem' }}>
            <a
              style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px', color: '#231444', textDecoration: 'underline', fontWeight: '700' }}
              onClick={(e) => handelAction(e, course)}
              title={"Publish"}> Review Course
            </a>

          </div>
          :
          course.status !== 'rejected' ?
            <>
            <span className='d-block text-center mb-2'>Mode: {course.accessMode}</span>
              <a
                style={{ cursor: 'pointer', marginRight: '10px', textTransform: 'capitalize' }} className={course.accessMode === 'public' ? 'mandatory-marked ' : 'public-marked'}
                onClick={(e) => handelAccessMode(e, course, course.accessMode !== 'public' ? 'public' : 'Mandatory')}
                title={course.accessMode !== 'public' ? 'Public' : 'Mandatory'}>
                <SuccessIcon /> &nbsp;{course.accessMode !== 'public' ? 'Public' : 'Mandatory'}
              </a>
            </>
            : ''
        }
      </td>
    </tr>
  )
}


const AllCourses = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState('');
  const [filterby, setFilterby] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [showAlert, setShowAlert] = useState({
    type: '',
    title: '',
    msg: ``,
    show: false

  });
  const [courseCount, setCourseCount] = useState({
    total: 0,
    pending: 0,
    approved: 0,
    rejected: 0
  });

  useEffect(() => {
    fetchCourse();
  }, []);
  useEffect(() => {
    const pubsubToken = subscribe('FETCH_VIDEO', () => {
      fetchCourse();
    });
    return () => unsubscribe(pubsubToken);
  }, []);
  const fetchCourse = async () => {
    setLoading(true)
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    apiClient.get(GETCOURSELIST)
      .then((response) => {
        if (response.status === 200) {
          setCourseCount({
            total: response.data.length,
            pending: response.data.filter(course => course.status === 'draft').length,
            approved: response.data.filter(course => course.status === 'published').length,
            rejected: response.data.filter(course => course.status === 'rejected').length
          })
          setCourses(response.data);
        } else {
          tempAlert.msg = 'Failed to load Courses';
          setShowAlert(tempAlert);
        }
      }).catch((error) => {
        tempAlert.msg = 'Failed to load Courses';
        setShowAlert(tempAlert);
      }).finally(() => {
        setLoading(false);
      });
  };

  const handelAction = async (e, item) => {
    navigate(`/viewcourses/${item?._id}`);
  }
  const handelAccessMode = (e, course, mode) => {
    let tempAlert = {
      type: 'danger',
      title: 'Error',
      msg: '',
      show: true
    }
    const data = { accessMode: mode };
    apiClient.put(`${GETCOURSELIST}/${course._id}`, data)
      .then((response) => {
        if (response.status === 200) {
          setCourses(prevCourses => prevCourses.map(c => c._id === course._id ? { ...c, accessMode: mode } : c));
          tempAlert.type = 'success';
          tempAlert.title = 'Success';
          tempAlert.msg = `✅ ${course.title} is marked as ${mode} successfully`;
        } else {
          tempAlert.msg = `❌ Failed to update accessMode of ${course.title}`;
        }
      }).catch((error) => {
        tempAlert.msg = `❌ Failed to update accessMode of ${course.title}`;
      }).finally(() => {
        setShowAlert(tempAlert);
      })
  }
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFilterby(value);
  }, []);

  const hideAlert = () => {
    setShowAlert({
      type: '',
      title: '',
      msg: '',
      show: false
    })
  }
  const handelGotoCourse = (e) => {
    navigate('/home');
  }
  const filtereditem = useMemo(() => {
    return filterby !== 'all'
      ? courses.filter(item => item.status.toLowerCase() === filterby.toLowerCase())
      : courses;
  }, [courses, filterby]);

  const searcheditem = useMemo(() => {
    const searchLower = search.toLowerCase();
    return filtereditem.filter(item =>
      item.title?.toLowerCase().includes(searchLower) ||
      (Array.isArray(item.tags) ? item.tags.join(' ').toLowerCase() : '').includes(searchLower)
    );
  }, [filtereditem, search]);
  const paginatedItem = useMemo(() => {
    return searcheditem.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
  }, [searcheditem, currentPage]);

  const totalPages = Math.ceil(searcheditem.length / pageSize);
  const handlePageChange = useCallback((pageNumber) => {
    setCurrentPage(pageNumber);
  }, []);
  if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading courses...</p>;
  if (error) return <p className='p-2 w-100 text-center m-3 bg-light'>{error}</p>;
  return (
    <>
      <div className="add-video-bg approve-course-container">
        <Row>
          <Col sm={10} className='approve-course-heading'> <h4 className="mb-0 fw-bold">Welcome User Name</h4> </Col>
          <Col md={2} className="text-end">
            <Button variant="outline-dark" onClick={handelGotoCourse}><BackArrowIcon />Go to dashboard</Button>
          </Col>
          <Row>
            <StatusCard count={courseCount.pending} status="Pending" />
            <StatusCard count={courseCount.rejected} status="Rejected" />
            <StatusCard count={courseCount.approved} status="published" />
            <StatusCard count={courseCount.total} status="total" />
          </Row>

        </Row>
      </div>
      <Container fluid className="mt-2 px-4">

        <Row className="justify-content-between align-items-center mb-1">
          <Col md={5}>
            <h6 className='fw-700'>Course List</h6>
          </Col>
          <Col md={4} >
            <Input
              label="Filter By"
              type="select"
              name="filterby"
              value={filterby}
              onChange={handleChange}
              multiple={false}
              options={[
                { value: 'all', label: 'All' },
                { value: 'published', label: 'Published' },
                { value: 'rejected', label: 'Rejected' },
                { value: 'draft', label: 'Draft' }
              ]}
            />
          </Col>
          <Col md={3} className='p-relative'>
            <InputGroup>
              <Form.Control
                placeholder="Search courses..."
                type='search'
                value={search}
                onChange={e => setSearch(e.target.value)}
                className='searchbox-input mb-3'
              />
            </InputGroup>
            <span className='search-icon2'></span>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Table responsive className='mytable'>
              <thead >
                <tr>
                  <th scope="col" className='txt-center'>S.No.</th>
                  <th scope="col" style={{ width: '25%' }}>Course Title</th>
                  <th scope="col">Description</th>
                  <th scope="col">Keywords</th>
                  <th scope="col" className='text-nowrap txt-center'>No. of <br />Videos</th>
                  <th scope="col" className='text-nowrap txt-center'>No. of <br />Questions</th>
                  <th scope="col" className='text-nowrap txt-center'>No. of <br />Reference Docs</th>
                  <th scope="col" className='text-nowrap'>Created <br />at</th>
                  <th scope="col" className='text-nowrap'>Created <br />by</th>
                  <th scope="col" className='text-nowrap'>Status</th>
                  <th scope="col" className='text-nowrap'>Actions <br />
                    <small style={{ fontSize: '10px', fontWeight: 'normal' }}>(Approve/Reject)</small></th>
                </tr>
              </thead>
              <tbody>
                {paginatedItem.map((course, idx) => {
                  return <CourseDetailTr key={idx} course={course} idx={idx} currentPage={currentPage} pageSize={pageSize} handelAction={handelAction} handelAccessMode={handelAccessMode} />
                })}
              </tbody>
            </Table>
          </Col>
          <Col lg={12}>
            <div className="d-flex justify-content-center">
              <Pagination className='mypagination-listing'>
                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                {[...Array(totalPages)].map((_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={currentPage === idx + 1}
                    onClick={() => handlePageChange(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
              </Pagination>
            </div></Col>
        </Row>

        {showAlert.show &&
          <AlertMassage
            show={showAlert.show}
            type={showAlert.type}
            title={showAlert.title}
            massage={showAlert.msg}
            hideAlert={hideAlert} />
        }

      </Container>
    </>

  );
};

export default AllCourses;